import { Component, ComponentFactoryResolver, ComponentRef, ViewChild, ViewContainerRef } from '@angular/core'
import { Router } from '@angular/router'
import { AgRendererComponent } from 'ag-grid-angular'
import { ICellRendererParams } from 'ag-grid-community'
import { ModalService } from '@collab/comp-library'
import { FileDownloadService } from 'src/app/shared/services/file-download.service'
import { CreateNewTicketService } from '../../services/create-new-ticket.service'
import { RequestHistoryRowDataI } from '../../constants/constants'
import { VolumeForecastingService } from '../../services/volume-forecasting.service'
import { CustomerSatisfactionReportService } from '../../services/customer-satisfaction-report.service'
import { FaqService } from '../../services/faq.service'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import { DebtAnalysisService } from '../../services/debt-analysis.service'
import { Observable } from 'rxjs'
import { LoaderService } from '../../services/loader.service'
import { saveAs } from 'file-saver'
import { TicketCustomPopupComponent } from '../ticket-custom-popup/ticket-custom-popup-renderer.component'
import { DebtCustomPopupComponent } from '../debt-custom-popup/debt-custom-popup-renderer.component'
import { VolumeForeactingCustomPopupComponent } from '../volume-forecasting-custom-popup/volume-forecasting-custom-popup-renderer.component'
import * as pdfMake from 'pdfmake/build/pdfmake'
import * as pdfFonts from 'pdfmake/build/vfs_fonts'
import { Content, TableCell } from 'pdfmake/interfaces'
import { TDocumentDefinitions } from 'pdfmake/interfaces'
import html2canvas from 'html2canvas'
import * as Highcharts from 'highcharts'
import HighchartsExporting from 'highcharts/modules/exporting'
import HighchartsOfflineExporting from 'highcharts/modules/offline-exporting'
import Drilldown from 'highcharts/modules/drilldown'
import HC_more from 'highcharts/highcharts-more'
import HighchartsMore from 'highcharts/highcharts-more'
import { LogAnalysisService } from '../../services/log-analysis.service'
import { DocumentService } from '../../services/document.service'
import { ChaosServiceService } from 'src/app/pages/devops-automation/service/chaos-service.service'
import { log } from 'node:console'
import { request } from 'node:https'
import { SelfServiceService } from '../../services/self-service.service'

HighchartsExporting(Highcharts)
HighchartsOfflineExporting(Highcharts)
HighchartsMore(Highcharts)
Drilldown(Highcharts)
HC_more(Highcharts);
(pdfMake as any).vfs = pdfFonts?.['vfs']

interface SOPStep {
    stepNumber: number
    activityName: string
    description: string
    responsibilities: string
    inputs: string
    outputs: string
    verificationChecks: string
    outputStatusIndicators: string
}
interface SOPDocument {
    documentRevisionHistory: any[]
    purpose: string
    scope: string
    outOfScope: string
    entryCriteria: string[]
    rasicMatrix: any[]
    jobAids: string[]
    activityFlowChart: string[]
    procedureSteps: SOPStep[]
    exitCriteria: string[]
    serviceLevelAgreements: any[]
    knownErrors: any[]
    vendorContacts: any[]
    escalationMatrix: any[]
}
interface KTDocument {
    documentInformation: {
        documentTitle: string
        authors: string
        version: string
        dateCreated: string
        documentPurpose: string
    }
    overview: {
        ktTopic: string
        background: string
        objectives: string[]
        scope: string
    }
    rolesAndResponsibilities: {
        knowledgeOwners: string
        knowledgeReceivers: string[]
        keyStakeholders: string[]
    }
    knowledgeAreas: {
        overviewOfKnowledgeAreas: string
        [key: string]: any
    }
    proceduresAndProtocols: {
        stepByStepProcedures: string[]
        protocols: string[]
    }
    toolsAndResources: {
        listOfTools: string[]
        documentation: string[]
        templates: string[]
    }
    trainingAndSupport: {
        trainingSessions: string[]
        supportResources: string[]
    }
    transitionPlan: {
        timeline: string
        milestones: string[]
        deliverables: string[]
    }
    reviewAndSignOff: {
        reviewers: string[]
        approval: string
    }
    appendices: {
        appendixA: string
    }
}
@Component({
    selector: 'app-actions-button-renderer',
    template: ` <div class="img-container">
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Reports"
            *ngIf="this.router.url === '/ticket-analytics/ticket-insights-table'"
            [ngClass]="isCompleted ? 'icon-enable' : 'icon-disable'"
            tabindex="0"
            (click)="viewTicket()"
        ></collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Download"
            *ngIf="this.router.url === '/ticket-analytics/ticket-insights-table'"
            [ngClass]="isCompleted ? 'icon-enable' : 'icon-disable'"
            tabindex="0"
            (click)="downloadViewTicket($event)"
        ></collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Delete"
            *ngIf="this.router.url === '/ticket-analytics/ticket-insights-table'"
            [ngClass]="'icon-enable'"
            tabindex="0"
            (click)="deleteTickets('deleteModel')">
        </collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Reports"
            *ngIf="this.router.url === '/ticket-analytics/volume-forecasting'"
            [ngClass]="isCompleted ? 'icon-enable' : 'icon-disable'"
            tabindex="0"
            (click)="viewForecasting()"
        ></collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Download"
            *ngIf="this.router.url === '/ticket-analytics/volume-forecasting'"
            [ngClass]="isCompleted ? 'icon-enable' : 'icon-disable'"
            tabindex="0"
            (click)="downloadvolumeForecasting($event)"
        ></collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Delete"
            *ngIf="this.router.url === '/ticket-analytics/volume-forecasting'"
            [ngClass]="'icon-enable'"
            tabindex="0"
            (click)="deleteForecasting('deleteModel')"
        >
        </collab-comp-img-generator>

        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Reports"
            *ngIf="this.router.url === '/feedback-analytics/feedback-analytics-table'"
            [ngClass]="isCompleted ? 'icon-enable' : 'icon-disable'"
            tabindex="0"
            (click)="viewCustomerReport()"
        ></collab-comp-img-generator>

        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Delete"
            *ngIf="this.router.url === '/feedback-analytics/feedback-analytics-table'"
            [ngClass]="'icon-enable'"
            tabindex="0"
            (click)="deleteFeedback('deleteModel')"
        >
        </collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Download"
            *ngIf="this.router.url === '/devops-automation/faq-table'"
            [ngClass]="isFaqDomain || isSegmentation ? 'icon-enable' : 'icon-disable'"
            tabindex="0"
            (click)="viewFaq()"
        ></collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Reports"
            *ngIf="this.router.url === '/ticket-analytics/debt-analysis-table'"
            [ngClass]="isCompleted ? 'icon-enable' : 'icon-disable'"
            tabindex="0"
            (click)="viewDebtAnalysis()"
        ></collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Download"
            *ngIf="this.router.url === '/ticket-analytics/debt-analysis-table'"
            [ngClass]="isCompleted ? 'icon-enable' : 'icon-disable'"
            tabindex="0"
            (click)="downloadViewDebtAnalysis($event)"
        ></collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Delete"
            *ngIf="this.router.url === '/ticket-analytics/debt-analysis-table'"
            [ngClass]="'icon-enable'"
            tabindex="0"
            (click)="deleteDebtAnalysis('deleteModel')"
        >
        </collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-View_On"
            *ngIf="this.router.url === '/aipo-observability/aipo-observability'"
            [ngClass]="inProgress ? 'icon-disable' : (isCompleted ? 'icon-enable' : 'icon-disable')"
            tabindex="0"
            (click)="viewObservability()"
        >
        </collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Delete"
            *ngIf="this.router.url === '/aipo-observability/aipo-observability'"
           [ngClass]="'icon-enable'"
            (click)="deleteObservability('deleteModel')"
        >
        </collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Reports"
            *ngIf="this.router.url === '/log-analysis/log-analysis-table'"
            [ngClass]="isCompleted ? 'icon-enable' : 'icon-disable'"
            tabindex="0"
            (click)="viewlogAnalysis()"
        ></collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-View_On"
            *ngIf="this.router.url === '/log-analysis/log-analysis-report/:requestId'"
            [ngClass]="isCompleted ? 'icon-enable' : 'icon-disable'"
            tabindex="0"
            (click)="viewlogAnalysis()"
        ></collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Reports"
            *ngIf="this.router.url === '/devops-automation/document-table'"
            [ngClass]="isDownloadEnabled ? 'icon-enable' : 'icon-disable'"
            tabindex="0"
            (click)="viewDocument()"
        ></collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Download"
            *ngIf="this.router.url === '/devops-automation/document-table'"
            [ngClass]="isDownloadEnabled ? 'icon-enable' : 'icon-disable'"
            tabindex="0"
            (click)="downloadDocument()"
        ></collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Delete"
           *ngIf="this.router.url === '/log-analysis/log-analysis-table'"
           [ngClass]="'icon-enable'"
            (click)="deleteLogAnalysis()"
        >
        </collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Delete"
           *ngIf="this.router.url === '/devops-automation/document-table'"
           [ngClass]="'icon-enable'"
            (click)="deleteDocumentationRecord()"
        >
        </collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-View_On"
            *ngIf="this.router.url === '/devops-automation/chaos-history'"
            [ngClass]="'icon-enable'"
            tabindex="0"
            (click)="viewChaosEngineering()"
        >
        </collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Delete"
           *ngIf="this.router.url === '/devops-automation/chaos-history'"
           [ngClass]="'icon-enable'"
            (click)="deleteChaosRecord()"
        >
        </collab-comp-img-generator>
        <!-- <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Edit"
           *ngIf="this.router.url === '/devops-automation/chaos-manage-config-table'"
           [ngClass]="'icon-enable'"
            (click)="updateManageConfig('config-choas-modal')">
        </collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Delete"
           *ngIf="this.router.url === '/devops-automation/chaos-manage-config-table'"
           [ngClass]="'icon-enable'"
            (click)="deleteChaosManageRecord()"
        >
        </collab-comp-img-generator> -->
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Delete"
            *ngIf="this.router.url === '/devops-automation/faq-table'"
            [ngClass]="'icon-enable'"
            tabindex="0"
            (click)="deleteFaqRecord()"
        ></collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Edit"
           *ngIf="this.router.url === '/devops-automation/self-service-playbook'"
           [ngClass]="'icon-enable'"
            (click)="updateSelfHelpPlaybook()">
        </collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Delete"
           *ngIf="this.router.url === '/devops-automation/self-service-playbook'"
           [ngClass]="'icon-enable'"
            (click)="deleteSelfHelpPlaybook()"
        >
        </collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Edit"
           *ngIf="this.router.url === '/devops-automation/chaos-manage-config-table'"
           [ngClass]="'icon-enable'"
            (click)="updateChoasworkflow()">
        </collab-comp-img-generator>
        <collab-comp-img-generator
            class="nav-icon"
            altText="texticon"
            fontClassName="icon-Delete"
           *ngIf="this.router.url === '/devops-automation/chaos-manage-config-table'"
           [ngClass]="'icon-enable'"
            (click)="deleteWorkflowRecord()">
        </collab-comp-img-generator> 
    </div>`,
    styles: [
        `
            img {
                margin-right: 10px;
                cursor: pointer;
            }
            .icon-disable {
                pointer-events: none;
                cursor: not-allowed;
                display: inline-block !important;
            }
            .icon-enable {
                cursor: pointer;
                display: inline-block !important;
                color: #3d3db8;
            }
            .icon-enable-delete {
                cursor: pointer;
                display: inline-block !important;
                color: #eb0000;
            }
        `,
    ],
})
export class ActionsButtonRendererComponent implements AgRendererComponent {
    public params!: ICellRendererParams;
    showReportIcon: boolean = false
    showDownloadIcon: boolean = false
    public selectedTicketRequestRow: RequestHistoryRowDataI | null = null
    constructor(
        private fileDownloadService: FileDownloadService,
        private modalService: ModalService,
        public createTicketService: CreateNewTicketService,
        private volumeForecastingService: VolumeForecastingService,
        public router: Router,
        private customerSatisfactionService: CustomerSatisfactionReportService,
        private faqService: FaqService,
        private debtAnalysisService: DebtAnalysisService,
        public loaderService: LoaderService,
        public viewContainerRef: ViewContainerRef,
        private logAnalysisService: LogAnalysisService,
        private documentService: DocumentService,
        private chaosService: ChaosServiceService,
        private selfhelpService:SelfServiceService
    ) { }

    get isCompleted() {
        return this.params.data.status === 'Completed'
    }
    get isFaqDomain() {
        return this.params.data.industry === 'OTHER'
    }
    get isSegmentation() {
        return this.params.data.industry === 'SEGMENTATION'
    }
    get iserror() {
        return this.params.data.status === 'error'
    }
    get inProgress() {
        return this.params.data.status === 'In Progress'
    }
    get isDownloadEnabled() {
        return this.isCompleted;
    }

    public agInit(params: any): void {
        this.params = params;
    }
    get isDownloadIconVisible(): boolean {
        const currentUrl = this.router.url
        return [
            '/feedback-analytics/feedback-analytics-report/promoters',
            '/feedback-analytics/feedback-analytics-report/passive',
            '/feedback-analytics/feedback-analytics-report/detractors',
        ].includes(currentUrl)
    }

    public viewTicket() {
        const requestId = this.params.data.requestId
        if (requestId && this.isCompleted) {
            this.createTicketService.setSelectedTestDesignRow(this.params.data)
            this.router.navigate(['/ticket-analytics/ticket-insights'])
        } else {
            console.error('Request ID not found in params.data')
        }
    }

    public downloadViewTicket(event: MouseEvent) {
        // Dynamically create the custom popup component
        const componentRef: ComponentRef<TicketCustomPopupComponent> =
            this.viewContainerRef.createComponent(TicketCustomPopupComponent)

        // Access the instance of the created component
        const customPopupInstance = componentRef.instance

        // Subscribe to events from the dynamically created component
        customPopupInstance.generatedFileClick.subscribe(() => {
            this.handleGeneratedFileClick()
            componentRef.destroy() // Destroy the component when done
        })
        customPopupInstance.uploadedFileClick.subscribe(() => {
            this.handleUploadedFileClick()
            componentRef.destroy() // Destroy the component when done
        })
        // Show the popup
        setTimeout(() => {
            return customPopupInstance.show(event)
        }, 500)
    }
    public handleGeneratedFileClick() {
        const requestId = this.params.data.requestId
        if (requestId && this.isCompleted) {
            const observable = this.createTicketService.setSelectedTestDesignRow(this.params.data, true)
            if (observable && observable instanceof Observable) {
                this.loaderService.show()
                observable.subscribe((res) => {
                    // Create a filename with requestId and timestamp
                    const filename = `${requestId}-${this.params.data.createdOn}-ticket_generatedfile`
                    // Pass the filename to createAndExportCharts
                    this.createTicketService.createAndExportCharts(res?.chartData, filename)
                    this.loaderService.hide()
                })
            }
        } else {
            console.error('Request ID not found in params.data')
        }
    }

    public handleUploadedFileClick() {
        const requestId = this.params.data.requestId
        if (requestId && this.isCompleted) {
            this.createTicketService.downloadUploadTicketFile(requestId).subscribe((res) => {
                const blob = new Blob([res], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                })
                saveAs(blob, `${this.params.data.requestId}-${this.params.data.createdOn}-ticket_uploadedfile.xlsx`)
            })
        } else {
            console.error('Request ID not found in params.data')
        }
    }
    public downloadvolumeForecasting(event: any) {
        // Dynamically create the custom popup component
        const componentRef: ComponentRef<VolumeForeactingCustomPopupComponent> = this.viewContainerRef.createComponent(
            VolumeForeactingCustomPopupComponent
        )

        // Access the instance of the created component
        const customPopupInstance = componentRef.instance

        // Subscribe to events from the dynamically created component
        customPopupInstance.generatedVlFileClick.subscribe(() => {
            this.handleGeneratedVolumeForecastingFileClick()
            componentRef.destroy() // Destroy the component when done
        })
        customPopupInstance.uploadedVlFileClick.subscribe(() => {
            this.handleUploadedVolumeForecastingFileClick()
            componentRef.destroy() // Destroy the component when done
        })
        // Show the popup
        setTimeout(() => {
            return customPopupInstance.show(event)
        }, 500)
    }
    public handleGeneratedVolumeForecastingFileClick() {
        const requestId = this.params.data.requestId
        if (requestId && this.isCompleted) {
            const observable = this.volumeForecastingService.setSelectedTestDesignRow(this.params.data, true)
            if (observable && observable instanceof Observable) {
                this.loaderService.show()
                observable.subscribe((res) => {
                    const filename = `${requestId}-${this.params.data.createdOn}-volumeForecasting_generatedfile`
                    this.volumeForecastingService.createAndExportVolumeForecastingCharts(res?.chartData, filename)
                    this.loaderService.hide()
                })
            }
        } else {
            console.error('Request ID not found in params.data')
        }
    }
    public handleUploadedVolumeForecastingFileClick() {
        const requestId = this.params.data.requestId
        if (requestId && this.isCompleted) {
            this.volumeForecastingService.downloadUploadVolumeForecastingFile(requestId).subscribe((res) => {
                const blob = new Blob([res], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                })
                saveAs(blob, `${this.params.data.requestId}-${this.params.data.createdOn}-Vf_uploadedfile.xlsx`)
            })
        } else {
            console.error('Request ID not found in params.data')
        }
    }

    public viewForecasting() {
        const requestId = this.params.data.requestId
        if (requestId && this.isCompleted) {
            this.volumeForecastingService.setSelectedTestDesignRow(this.params.data)
            this.router.navigate(['/ticket-analytics/volume-forecasting-details'])
        } else {
            console.error('Request ID not found in params.data')
        }
    }
    public viewFaq() {
        const requestId = this.params.data.requestId
        if (requestId || this.isFaqDomain || this.isSegmentation) {
            this.faqService.setSelectedTestDesignRow(this.params.data)
            const data = this.params.node.data
        } else {
            console.error('Request ID not found in params.data')
        }
    }

    public viewCustomerReport() {
        const requestId = this.params.data.requestId
        if (requestId && this.isCompleted) {
            this.customerSatisfactionService.setSelectedTestDesignRow(this.params.data)
            this.router.navigate(['/feedback-analytics/feedback-analytics-report'])
        } else {
            console.error('Request ID not found in params.data')
        }
    }
    public viewDebtAnalysis() {
        const requestId = this.params.data.requestId
        if (requestId && this.isCompleted) {
            this.debtAnalysisService.setSelectedTestDesignRow(this.params.data)
            this.router.navigate(['/ticket-analytics/Debt-Analysis'])
        } else {
            console.error('Request ID not found in params.data')
        }
    }
    public downloadViewDebtAnalysis(event: any) {
        const componentRef: ComponentRef<DebtCustomPopupComponent> =
            this.viewContainerRef.createComponent(DebtCustomPopupComponent)
        const customPopupInstance = componentRef.instance

        customPopupInstance.generatedDebtFileClick.subscribe(() => {
            this.handleGeneratedDebtFileClick()
            componentRef.destroy()
        })
        customPopupInstance.uploadedDebtFileClick.subscribe(() => {
            this.downloadUploadedDebtFile()
            componentRef.destroy()
        })
        customPopupInstance.processedDebtFileClick.subscribe(() => {
            this.processedUploadedDebtFile()
            componentRef.destroy()
        })

        setTimeout(() => {
            customPopupInstance.show(event)
        }, 500)
    }

    private handleGeneratedDebtFileClick() {
        const requestId = this.params.data.requestId
        if (requestId && this.isCompleted) {
            this.loaderService.show()
            const observable = this.debtAnalysisService.getSelectedDebtAnalysis(requestId)
            if (observable && observable instanceof Observable) {
                observable.subscribe((response) => {
                    this.generateAndDownloadPDF(response, requestId)
                    this.loaderService.hide()
                })
            }
        } else {
            console.error('Request ID not found in params.data or status is not Completed')
        }
    }

    private async generateAndDownloadPDF(data: any, requestId: string) {
        try {
            const chartImage = await this.captureChart(data.chartData)
            const operationalData = this.extractGridData(data.chartData, 'Operational')
            const technicalData = this.extractGridData(data.chartData, 'Technical')
            const functionalData = this.extractGridData(data.chartData, 'Functional')

            const docDefinition: TDocumentDefinitions = {
                content: [
                    { text: `Debt Analysis - Request ID: ${requestId}`, style: 'header' },
                    { image: chartImage, width: 500 },
                    { text: 'Operational', style: 'subheader' },
                    this.createGridTable(operationalData),
                    { text: 'Technical', style: 'subheader' },
                    this.createGridTable(technicalData),
                    { text: 'Functional', style: 'subheader' },
                    this.createGridTable(functionalData),
                ],
                styles: {
                    header: {
                        fontSize: 18,
                        bold: true,
                        margin: [0, 0, 0, 10],
                    },
                    subheader: {
                        fontSize: 16,
                        bold: true,
                        margin: [0, 10, 0, 5],
                    },
                    tableHeader: {
                        bold: true,
                        fontSize: 13,
                        color: 'black',
                    },
                    subHeader: {
                        bold: true,
                        fontSize: 12,
                        color: 'black',
                        fillColor: '#DDDDDD',
                    },
                },
            }

            pdfMake
                .createPdf(docDefinition)
                .download(`${requestId}-${this.params.data.createdOn}-debt_analysis_report.pdf`)
        } catch (error) {
            console.error('Error generating PDF:', error)
        }
    }

    private captureChart(chartData: any): Promise<string> {
        return new Promise((resolve, reject) => {
            const chartOptions = this.createChartOptions(chartData)

            const tempContainer = document.createElement('div')
            tempContainer.id = 'tempChartContainer'
            tempContainer.style.width = '800px'
            tempContainer.style.height = '400px'
            tempContainer.style.position = 'absolute'
            tempContainer.style.left = '-9999px' // Position off-screen
            document.body.appendChild(tempContainer)

            Highcharts.chart('tempChartContainer', chartOptions, function (chart) {
                // Wait for the chart to render
                setTimeout(() => {
                    html2canvas(tempContainer)
                        .then((canvas) => {
                            const dataURL = canvas.toDataURL('image/png')
                            resolve(dataURL)

                            // Clean up
                            document.body.removeChild(tempContainer)
                        })
                        .catch(reject)
                }, 1000) // Adjust timeout if needed
            })
        })
    }

    private createChartOptions(chartData: any): Highcharts.Options {
        const allowedCategories = ['Operational', 'Technical', 'Functional']
        const avoidableSeriesData: any[] = []
        const unavoidableSeriesData: any[] = []

        allowedCategories.forEach((category) => {
            const item = chartData.debtAnalysis.find((i: any) => i.debt === category)
            if (item) {
                avoidableSeriesData.push({
                    name: `${category} (Avoidable)`,
                    y: item.avoidablePercentage,
                    color: '#6666CC',
                })
                unavoidableSeriesData.push({
                    name: `${category} (Unavoidable)`,
                    y: item.unavoidablePercentage,
                    color: '#008567',
                })
            } else {
                // ... (handle case when item is not found)
            }
        })

        return {
            chart: {
                type: 'column',
                events: {
                    load: function () {
                        this.renderer
                            .image(
                                'https://www.highcharts.com/samples/graphics/export-icon.png',
                                this.chartWidth - 50,
                                10,
                                30,
                                30
                            )
                            .css({
                                cursor: 'pointer',
                            })
                            .add()
                    },
                },
            },
            xAxis: {
                categories: allowedCategories,
                labels: {
                    style: {
                        fontWeight: '600',
                    },
                },
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Debt',
                    style: {
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#000000',
                    },
                },
                stackLabels: {
                    enabled: true,
                },
            },
            exporting: {
                enabled: false,
                buttons: {
                    contextButton: {
                        menuItems: [
                            'viewFullscreen',
                            'printChart',
                            'separator',
                            'downloadPNG',
                            'downloadJPEG',
                            'downloadPDF',
                            'downloadSVG',
                        ],
                    },
                },
            },
            credits: {
                enabled: false,
            },
            title: {
                text: 'Debt Analysis',
                margin: 50,
                align: 'left',
                y: 20,
                x: 25,
            },
            legend: {
                align: 'center',
                verticalAlign: 'bottom',
                layout: 'horizontal',
                itemMarginTop: 10,
                itemWidth: 150,
                itemStyle: {
                    fontWeight: 'normal',
                    fontSize: '14px',
                    color: '#333333',
                },
                itemHoverStyle: {
                    color: '#000000',
                },
            },
            plotOptions: {
                column: {
                    pointWidth: 50,
                    pointPadding: 0,
                    groupPadding: 0,
                    borderWidth: 0,
                    stacking: 'normal',
                    dataLabels: {
                        enabled: true,
                        allowOverlap: true,
                        style: {
                            color: 'white',
                            textOutline: 'none',
                            fontSize: '8px',
                        },
                        formatter: function () {
                            return `${this.y}`
                        },
                    },
                },
            },
            tooltip: {
                headerFormat: '<b>{point.x}</b><br/>',
                pointFormat: '{series.name}: {point.y}%<br/>Total: {point.stackTotal}%',
            },
            series: [
                {
                    type: 'column',
                    name: 'Avoidable',
                    data: avoidableSeriesData,
                    color: '#6666CC',
                },
                {
                    type: 'column',
                    name: 'Unavoidable',
                    data: unavoidableSeriesData,
                    color: '#008567',
                },
            ],
        }
    }

    private extractGridData(chartData: any, debtType: string): any[] {
        const rowData: any[] = []
        const debtItem = chartData.debtAnalysis.find((item: any) => item.debt === debtType)

        if (debtItem && debtItem.avoidableCategoryData?.length > 0) {
            debtItem.avoidableCategoryData.forEach((categoryData: any) => {
                rowData.push({
                    category: categoryData.category,
                    count: categoryData.count,
                    scopeOfAutomation: categoryData.scopeOfAutomation,
                    automationRecommendations: categoryData.automationRecommendations || [],
                })
            })
        }

        return rowData
    }

    private createGridTable(data: any[]): Content {
        if (data.length === 0) {
            return { text: 'No data available', italics: true, margin: [0, 0, 0, 10] }
        }

        const tableBody: TableCell[][] = [
            [
                { text: 'Category', style: 'tableHeader' },
                { text: 'No of Avoidable Issues', style: 'tableHeader' },
                { text: 'Scope of Automation', style: 'tableHeader' },
            ],
        ]

        data.forEach((row) => {
            tableBody.push([row.category, row.count.toString(), row.scopeOfAutomation])

            // Add automation recommendations
            tableBody.push([
                { text: 'Automation Recommendations', style: 'subHeader', colSpan: 3 } as TableCell,
                {}, // Empty cells for colspan
                {},
            ])

            if (row.automationRecommendations && row.automationRecommendations.length > 0) {
                tableBody.push([
                    {
                        colSpan: 3,
                        table: {
                            widths: ['*', 'auto'],
                            body: [
                                [
                                    { text: 'Cluster', style: 'tableHeader' },
                                    { text: 'Percentage', style: 'tableHeader' },
                                ],
                                ...row.automationRecommendations.map((rec: any) => [
                                    rec.clusterInfo,
                                    rec.percentage + '%',
                                ]),
                            ],
                        },
                        layout: 'lightHorizontalLines',
                    } as TableCell,
                    {}, // Empty cells for colspan
                    {},
                ])
            } else {
                tableBody.push([
                    {
                        text: 'No data available for clusters and percentages',
                        italics: true,
                        margin: [0, 0, 0, 10],
                        colSpan: 3,
                    } as TableCell,
                    {}, // Empty cells for colspan
                    {},
                ])
            }
        })

        return {
            table: {
                headerRows: 1,
                widths: ['*', 'auto', 'auto'],
                body: tableBody,
            },
            layout: {
                fillColor: (rowIndex: number, node: any, columnIndex: number) => {
                    return rowIndex % 2 === 0 && rowIndex !== 0 ? '#F2F2F2' : null
                },
            },
            margin: [0, 0, 0, 10],
        }
    }

    public downloadUploadedDebtFile() {
        const requestId = this.params.data.requestId
        if (requestId && this.isCompleted) {
            this.debtAnalysisService.UploadDebtAnalysisFile(requestId).subscribe((res) => {
                const blob = new Blob([res], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                })
                saveAs(blob, `${this.params.data.requestId}-${this.params.data.createdOn}-Debt_uploadedfile.xlsx`)
            })
        } else {
            console.error('Request ID not found in params.data')
        }
    }
    public processedUploadedDebtFile() {
        const requestId = this.params.data.requestId
        if (requestId && this.isCompleted) {
            this.debtAnalysisService.ProcessedDebtAnalysisFile(requestId).subscribe((res) => {
                const blob = new Blob([res], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                })
                saveAs(blob, `${this.params.data.requestId}-${this.params.data.createdOn}-Debt_processedfile.xlsx`)
            })
        } else {
            console.error('Request ID not found in params.data')
        }
    }
    public viewObservability() {
        const requestId = this.params.data.requestId
        if (requestId && this.isCompleted) {
            this.debtAnalysisService.setSelectedTestDesignRow(this.params.data)
            this.router.navigate(['/aipo-observability/aipo-observability'])
        } else {
            console.error('Request ID not found in params.data')
        }
    }
    public viewlogAnalysis() {
        const requestId = this.params.data.requestId
        if (requestId && this.isCompleted) {
            this.logAnalysisService.getLogAnalysisReport(this.params.data)
            this.router.navigate(['/log-analysis/log-analysis-report', requestId])
        } else {
            console.error('Request ID not found in params.data')
        }
    }
    public downloadDocument(): void {
        if (this.isDownloadEnabled) {
            const requestId = this.params.data.requestId;
            if (requestId) {
                this.documentService.getDocumentResponse(requestId).subscribe({
                    next: (response: any) => {
                        if (response && response.status === 'Success') {
                            const docDefinition = this.generatePDFDocument(response);
                            pdfMake
                                .createPdf(docDefinition)
                                .download(`${response.documentType}_Document_${requestId}.pdf`);
                        } else {
                            console.error('Invalid response structure:', response);
                        }
                    },
                    error: (error: any) => {
                        console.error('Error fetching document response:', error);
                    },
                });
            } else {
                console.error('Request ID not found in params.data');
            }
        } else {
            console.warn('Download not allowed. Document status is not Completed.');
        }
    }
    private generatePDFDocument(data: any): any {
        switch (data.documentType) {
            case 'SOP':
                return this.generateSOPDocument(data.sopResponse.sop)
            case 'KT':
                return this.generateKTDocument(data.ktResponse)
            case 'BRD':
                return this.generateBRDDocument(data)
            case 'Summary Document':
                return this.generateSummaryDocument(data)
            default:
                console.error('Unknown document type:', data.documentType)
                return { content: [{ text: 'Unsupported document type', style: 'header' }] }
        }
    }
    private generateSOPDocument(sop: any): any {
        const content: any[] = [
            { text: 'Standard Operating Procedure (SOP)', style: 'header', alignment: 'center' },

            // 1. Document Revision History
            { text: '1. Document Revision History', style: 'sectionHeader' },
            this.createTable(sop.documentRevisionHistory, [
                'Document Version',
                'Approval Date',
                'Modified By',
                'Section/Page/Text Revised',
                'Approved By'
            ]),

            // 2. Purpose
            { text: '2. Purpose', style: 'sectionHeader' },
            { text: sop.purpose, margin: [20, 0, 0, 10] },

            // 3. Scope
            { text: '3. Scope', style: 'sectionHeader' },
            { text: sop.scope, margin: [20, 0, 0, 10] },

            // 4. Out of Scope
            { text: '4. Out of Scope', style: 'sectionHeader' },
            { text: sop.outOfScope, margin: [20, 0, 0, 10] },

            // 5. Entry Criteria
            { text: '5. Entry Criteria', style: 'sectionHeader' },
            this.createBulletList(sop.entryCriteria, 20),

            // 6. RASIC Matrix
            { text: '6. RASIC Matrix', style: 'sectionHeader' },
            this.createTable(sop.rasicMatrix, [
                'Primary Activity',
                'Responsible',
                'Accountable',
                'Supported',
                'Informed',
                'Consulted'
            ]),

            // 7. Job Aids
            { text: '7. Job Aids', style: 'sectionHeader' },
            this.createBulletList(sop.jobAids, 20),

            // 8. Activity Flow Chart
            { text: '8. Activity Flow Chart', style: 'sectionHeader' },
            this.createBulletList(sop.activityFlowChart, 20),

            // 9. Procedure Steps
            { text: '9. Procedure Steps', style: 'sectionHeader' },
            ...sop.procedureSteps.map((step: any) => [
                { text: `Step ${step.stepNumber}: ${step.activityName}`, style: 'subheader' },
                { text: [{ text: 'Description: ', bold: true }, step.description], margin: [20, 5, 0, 5] },
                { text: [{ text: 'Responsibilities: ', bold: true }, step.responsibilities], margin: [20, 0, 0, 5] },
                { text: [{ text: 'Inputs: ', bold: true }, step.inputs], margin: [20, 0, 0, 5] },
                { text: [{ text: 'Outputs: ', bold: true }, step.outputs], margin: [20, 0, 0, 5] },
                { text: [{ text: 'Verification Checks: ', bold: true }, step.verificationChecks], margin: [20, 0, 0, 5] },
                { text: [{ text: 'Output Status Indicators: ', bold: true }, step.outputStatusIndicators], margin: [20, 0, 0, 10] }
            ]).flat(),

            // 10. Exit Criteria
            { text: '10. Exit Criteria', style: 'sectionHeader' },
            this.createBulletList(sop.exitCriteria, 20),

            // 11. Service Level Agreements
            { text: '11. Service Level Agreements', style: 'sectionHeader' },
            this.createTable(sop.serviceLevelAgreements, [
                'Title',
                'Description',
                'Expected Service Level',
                'Minimum Service Level'
            ]),

            // 12. Known Errors
            { text: '12. Known Errors', style: 'sectionHeader' },
            this.createTable(sop.knownErrors, ['Error', 'Solution']),

            // 13. Vendor Contacts
            { text: '13. Vendor Contacts', style: 'sectionHeader', pageBreakBefore: true },
            this.createTable(sop.vendorContacts, ['Vendor', 'Contact Information']),

            // 14. Escalation Matrix
            { text: '14. Escalation Matrix', style: 'sectionHeader' },
            this.createTable(sop.escalationMatrix, ['Role', 'Department', 'Contact Information'])
        ];

        return {
            ...this.getDocumentSettings(),
            content: content,
            styles: this.getDefaultStyles(),
            pageSize: 'A4',
            pageOrientation: 'portrait',
            pageMargins: [40, 60, 40, 60]
        };
    }
    private generateKTDocument(kt: any): any {
        const content: any[] = [
            { text: 'Knowledge Transfer Document', style: 'header', alignment: 'center' },

            // 1. Document Information
            { text: '1. Document Information', style: 'sectionHeader' },
            this.createTable([{
                documentTitle: kt.documentInformation.documentTitle,
                authors: kt.documentInformation.authors,
                version: kt.documentInformation.version,
                dateCreated: kt.documentInformation.dateCreated,
                documentPurpose: kt.documentInformation.documentPurpose
            }], ['Document Title', 'Authors', 'Version', 'Date Created', 'Document Purpose']),

            // 2. Overview
            { text: '2. Overview', style: 'sectionHeader' },
            { text: 'KT Topic:', style: 'subheader' },
            { text: kt.overview.ktTopic, margin: [20, 0, 0, 10] },
            { text: 'Background:', style: 'subheader' },
            { text: kt.overview.background, margin: [20, 0, 0, 10] },
            { text: 'Objectives:', style: 'subheader' },
            this.createBulletList(kt.overview.objectives, 20),
            { text: 'Scope:', style: 'subheader' },
            { text: kt.overview.scope, margin: [20, 0, 0, 10] },

            // 3. Roles and Responsibilities
            { text: '3. Roles and Responsibilities', style: 'sectionHeader' },
            this.createTable([{
                knowledgeOwners: kt.rolesAndResponsibilities.knowledgeOwners,
                knowledgeReceivers: Array.isArray(kt.rolesAndResponsibilities.knowledgeReceivers)
                    ? kt.rolesAndResponsibilities.knowledgeReceivers.join(', ')
                    : kt.rolesAndResponsibilities.knowledgeReceivers,
                keyStakeholders: Array.isArray(kt.rolesAndResponsibilities.keyStakeholders)
                    ? kt.rolesAndResponsibilities.keyStakeholders.join(', ')
                    : kt.rolesAndResponsibilities.keyStakeholders
            }], ['Knowledge Owners', 'Knowledge Receivers', 'Key Stakeholders']),

            // 4. Knowledge Areas
            { text: '4. Knowledge Areas', style: 'sectionHeader' },
            { text: 'Overview:', style: 'subheader' },
            { text: kt.knowledgeAreas.overviewOfKnowledgeAreas, margin: [20, 0, 0, 10] },

            // Iterate through knowledge areas
            ...Object.keys(kt.knowledgeAreas)
                .filter(key => key !== 'overviewOfKnowledgeAreas')
                .map((areaKey, index) => [
                    { text: `Area ${index + 1}:`, style: 'subheader' },
                    { text: 'Key Processes:', style: 'subsubheader', margin: [20, 5, 0, 0] },
                    this.createBulletList(kt.knowledgeAreas[areaKey].keyProcesses, 40),
                    { text: 'Tools and Systems:', style: 'subsubheader', margin: [20, 5, 0, 0] },
                    this.createBulletList(kt.knowledgeAreas[areaKey].toolsAndSystems, 40),
                    { text: 'Best Practices:', style: 'subsubheader', margin: [20, 5, 0, 0] },
                    this.createBulletList(kt.knowledgeAreas[areaKey].bestPractices, 40),
                ]).flat(),

            // 5. Procedures and Protocols
            { text: '5. Procedures and Protocols', style: 'sectionHeader' },
            { text: 'Step-by-Step Procedures:', style: 'subheader' },
            this.createBulletList(kt.proceduresAndProtocols.stepByStepProcedures, 20),
            { text: 'Protocols:', style: 'subheader' },
            this.createBulletList(kt.proceduresAndProtocols.protocols, 20),

            // 6. Tools and Resources
            { text: '6. Tools and Resources', style: 'sectionHeader' },
            { text: 'List of Tools:', style: 'subheader' },
            this.createBulletList(kt.toolsAndResources.listOfTools, 20),
            { text: 'Documentation:', style: 'subheader' },
            this.createBulletList(kt.toolsAndResources.documentation, 20),
            { text: 'Templates:', style: 'subheader' },
            this.createBulletList(kt.toolsAndResources.templates, 20),

            // 7. Training and Support
            { text: '7. Training and Support', style: 'sectionHeader' },
            { text: 'Training Sessions:', style: 'subheader' },
            this.createBulletList(kt.trainingAndSupport.trainingSessions, 20),
            { text: 'Support Resources:', style: 'subheader' },
            this.createBulletList(kt.trainingAndSupport.supportResources, 20),

            // 8. Transition Plan
            { text: '8. Transition Plan', style: 'sectionHeader' },
            { text: 'Timeline:', style: 'subheader' },
            { text: kt.transitionPlan.timeline, margin: [20, 0, 0, 10] },
            { text: 'Milestones:', style: 'subheader' },
            this.createBulletList(kt.transitionPlan.milestones, 20),
            { text: 'Deliverables:', style: 'subheader' },
            this.createBulletList(kt.transitionPlan.deliverables, 20),

            // 9. Review and Sign-off
            { text: '9. Review and Sign-off', style: 'sectionHeader' },
            { text: 'Reviewers:', style: 'subheader' },
            this.createBulletList(kt.reviewAndSignOff.reviewers, 20),
            { text: 'Approval:', style: 'subheader' },
            { text: kt.reviewAndSignOff.approval, margin: [20, 0, 0, 10] },

            // 10. Appendices
            { text: '10. Appendices', style: 'sectionHeader' },
            { text: 'Appendix A:', style: 'subheader' },
            { text: kt.appendices.appendixA, margin: [20, 0, 0, 10] }
        ];

        return {
            ...this.getDocumentSettings(),
            content: content,
            styles: this.getDefaultStyles(),
            pageSize: 'A4',
            pageOrientation: 'portrait',
            pageMargins: [40, 60, 40, 60]
        };
    }
    private generateBRDDocument(brdResponse: any): any {
        const brd = brdResponse?.brdDocument || {};

        const content: any[] = [
            { text: 'Business Requirements Document (BRD)', style: 'header', alignment: 'center' },
        ];

        // 1. Document Control
        if (brd.documentControl) {
            content.push(
                { text: '1. Document Control', style: 'sectionHeader' },
                this.createTable([{
                    documentTitle: brd.documentControl.documentTitle[0],
                    version: brd.documentControl.version[0],
                    date: brd.documentControl.date[0],
                    preparedBy: brd.documentControl.preparedBy[0],
                    reviewedBy: brd.documentControl.reviewedBy[0],
                    approvedBy: brd.documentControl.approvedBy[0],
                    documentId: brd.documentControl.documentId[0]
                }], ['Document Title', 'Version', 'Date', 'Prepared by', 'Reviewed by', 'Approved by', 'Document ID'])
            );
        }

        // 2. Executive Summary
        if (brd.executiveSummary) {
            content.push(
                { text: '2. Executive Summary', style: 'sectionHeader' },
                { text: 'Purpose of the Document:', style: 'subheader' },
                { text: brd.executiveSummary.purposeOfTheDocument[0] || 'Not specified', margin: [20, 0, 0, 10] },
                { text: 'Project Overview:', style: 'subheader' },
                { text: brd.executiveSummary.projectOverview[0] || 'Not specified', margin: [20, 0, 0, 10] },
                { text: 'Scope:', style: 'subheader' },
                { text: brd.executiveSummary.scope[0] || 'Not specified', margin: [20, 0, 0, 10] },
                { text: 'Stakeholders:', style: 'subheader' },
                this.createBulletList(brd.executiveSummary.stakeholders || [], 20)
            );
        }

        // 3. Business Objectives
        if (brd.businessObjectives) {
            content.push(
                { text: '3. Business Objectives', style: 'sectionHeader' },
                this.createBulletList(brd.businessObjectives, 20)
            );
        }

        // 4. Business Requirements
        if (brd.businessRequirements) {
            content.push(
                { text: '4. Business Requirements', style: 'sectionHeader' },
                { text: 'Functional Requirements:', style: 'subheader' },
                {
                    ul: brd.businessRequirements.functionalRequirements.map((req: string) => ({
                        text: req,
                        margin: [20, 0, 0, 5]
                    }))
                },
                { text: 'Non-Functional Requirements:', style: 'subheader' },
                { text: 'Performance Requirements:', style: 'subsubheader', margin: [20, 5, 0, 5] },
                {
                    ul: [{
                        text: brd.businessRequirements.nonFunctionalRequirements.performanceRequirements[0] || 'Not specified',
                        margin: [40, 0, 0, 5]
                    }]
                },
                { text: 'Security Requirements:', style: 'subsubheader', margin: [20, 5, 0, 5] },
                {
                    ul: [{
                        text: brd.businessRequirements.nonFunctionalRequirements.securityRequirements[0] || 'Not specified',
                        margin: [40, 0, 0, 5]
                    }]
                },
                { text: 'Compliance Requirements:', style: 'subsubheader', margin: [20, 5, 0, 5] },
                {
                    ul: [{
                        text: brd.businessRequirements.nonFunctionalRequirements.complianceRequirements[0] || 'Not specified',
                        margin: [40, 0, 0, 5]
                    }]
                }
            );
        }

        // 5. Scope of Work
        if (brd.scopeOfWork) {
            content.push(
                { text: '5. Scope of Work', style: 'sectionHeader' },
                { text: 'In-Scope Items:', style: 'subheader' },
                this.createBulletList(brd.scopeOfWork.inScopeItems || [], 20),
                { text: 'Out-of-Scope Items:', style: 'subheader' },
                this.createBulletList(brd.scopeOfWork.outOfScopeItems || [], 20)
            );
        }

        // 6. Assumptions and Constraints
        if (brd.assumptionsAndConstraints) {
            content.push(
                { text: '6. Assumptions and Constraints', style: 'sectionHeader' },
                { text: 'Assumptions:', style: 'subheader' },
                this.createBulletList(brd.assumptionsAndConstraints.assumptions || [], 20),
                { text: 'Constraints:', style: 'subheader' },
                this.createBulletList(brd.assumptionsAndConstraints.constraints || [], 20)
            );
        }

        // 7. Stakeholder Analysis
        if (brd.stakeholderAnalysis) {
            content.push(
                { text: '7. Stakeholder Analysis', style: 'sectionHeader' },
                this.createTable(brd.stakeholderAnalysis.map((stakeholder: any) => ({
                    stakeholderName: stakeholder.stakeholderName[0],
                    role: stakeholder.role[0],
                    interestInfluence: stakeholder.interestInfluence[0]
                })), ['Stakeholder Name', 'Role', 'Interest/Influence'])
            );
        }

        // 8. Current State Analysis
        if (brd.currentStateAnalysis) {
            content.push(
                { text: '8. Current State Analysis', style: 'sectionHeader' },
                { text: 'Existing Systems:', style: 'subheader' },
                { text: brd.currentStateAnalysis.existingSystems[0] || 'Not specified', margin: [20, 0, 0, 10] },
                { text: 'Challenges:', style: 'subheader' },
                this.createBulletList(brd.currentStateAnalysis.challenges || [], 20)
            );
        }

        // 9. Future State
        if (brd.futureState) {
            content.push(
                { text: '9. Future State', style: 'sectionHeader' },
                { text: 'Proposed Solution:', style: 'subheader' },
                { text: brd.futureState.proposedSolution[0] || 'Not specified', margin: [20, 0, 0, 10] },
                { text: 'Benefits:', style: 'subheader' },
                this.createBulletList(brd.futureState.benefits || [], 20)
            );
        }

        // 10. Requirements Traceability Matrix
        if (brd.requirementsTraceabilityMatrix) {
            content.push(
                { text: '10. Requirements Traceability Matrix', style: 'sectionHeader' },
                this.createTable(brd.requirementsTraceabilityMatrix.map((req: any) => ({
                    requirementId: req.requirementId[0],
                    requirementDescription: req.requirementDescription[0],
                    priority: req.priority[0],
                    source: req.source[0],
                    owner: req.owner[0],
                    status: req.status[0]
                })), ['Requirement ID', 'Requirement Description', 'Priority', 'Source', 'Owner', 'Status'])
            );
        }

        // 11. Risks and Mitigations
        if (brd.risksAndMitigations) {
            content.push(
                { text: '11. Risks and Mitigations', style: 'sectionHeader' },
                ...brd.risksAndMitigations.map((risk: any, index: number) => [
                    { text: `Risk ${index + 1}: ${risk.risk[0]}`, style: 'subheader' },
                    {
                        ul: [
                            { text: [{ text: 'Likelihood: ', bold: true }, risk.likelihood[0]], margin: [0, 0, 0, 5] },
                            { text: [{ text: 'Impact: ', bold: true }, risk.impact[0]], margin: [0, 0, 0, 5] },
                            { text: [{ text: 'Mitigation Strategy: ', bold: true }, risk.mitigationStrategy[0]], margin: [0, 0, 0, 5] },
                        ],
                        margin: [20, 0, 0, 10]
                    },
                ]).flat()
            );
        }

        // 12. Change Management Plan
        if (brd.changeManagementPlan) {
            content.push(
                { text: '12. Change Management Plan', style: 'sectionHeader' },
                { text: 'Change Control Process:', style: 'subheader' },
                { text: brd.changeManagementPlan.changeControlProcess[0] || 'Not specified', margin: [20, 0, 0, 10] },
                { text: 'Communication Plan:', style: 'subheader' },
                { text: brd.changeManagementPlan.communicationPlan[0] || 'Not specified', margin: [20, 0, 0, 10] }
            );
        }

        // 13. Appendices
        if (brd.appendices) {
            content.push(
                { text: '13. Appendices', style: 'sectionHeader' },
                { text: 'Appendix A: ' + (brd.appendices.appendixA[0] || 'Not specified'), style: 'subheader' },
                { text: 'Appendix B: ' + (brd.appendices.appendixB[0] || 'Not specified'), style: 'subheader' },
                { text: 'Appendix C: ' + (brd.appendices.appendixC[0] || 'Not specified'), style: 'subheader' }
            );
        }

        // 14. Sign-off
        if (brd.signOff) {
            content.push(
                { text: '14. Sign-off', style: 'sectionHeader' },
                this.createTable([{
                    preparedBy: brd.signOff.preparedBy[0],
                    reviewedBy: brd.signOff.reviewedBy[0],
                    approvedBy: brd.signOff.approvedBy[0]
                }], ['Prepared by', 'Reviewed by', 'Approved by'])
            );
        }

        return {
            ...this.getDocumentSettings(),
            content: content,
            styles: this.getDefaultStyles(),
            pageSize: 'A4',
            pageOrientation: 'portrait',
            pageMargins: [40, 60, 40, 60],
        };
    }
    private generateSummaryDocument(summaryResponse: any): any {
        const summary = summaryResponse?.summaryDocument || {};

        const content: any[] = [
            { text: 'Meeting Summary Document', style: 'header', alignment: 'center' },

            // 1. Basic Information
            {
                text: '1. Basic Information',
                style: 'sectionHeader',
                pageBreakBefore: true,
                keepWithNext: true
            }
        ];

        // Handle Basic Information
        if (summary.basicInformation && summary.basicInformation.length > 0 &&
            (summary.basicInformation[0].meetingDate || summary.basicInformation[0].meetingTime)) {
            content.push(
                this.createTable([{
                    meetingDate: summary.basicInformation[0].meetingDate || 'Not Specified',
                    meetingTime: summary.basicInformation[0].meetingTime || 'Not Specified'
                }], ['Meeting Date', 'Meeting Time'])
            );
        } else {
            content.push({ text: 'Not Specified', margin: [20, 0, 0, 10], italics: true });
        }

        // 2. Participants
        content.push({
            text: '2. Participants',
            style: 'sectionHeader',
            pageBreakBefore: true,
            keepWithNext: true
        });

        if (summary.participants && summary.participants.length > 0) {
            const participantsData = summary.participants.map((participant: any) => ({
                fullName: participant.fullName || 'Not Specified',
                role: participant.role || 'Not Specified',
                specialDesignation: participant.specialDesignation || 'Not Specified'
            }));
            content.push(
                this.createTable(participantsData, ['Full Name', 'Role', 'Special Designation'])
            );
        } else {
            content.push({ text: 'Not Specified', margin: [20, 0, 0, 10], italics: true });
        }

        // 3. Purpose of Discussion
        content.push({
            text: '3. Purpose of Discussion',
            style: 'sectionHeader',
            pageBreakBefore: true,
            keepWithNext: true
        });

        if (summary.purposeOfDiscussion && summary.purposeOfDiscussion.length > 0 && summary.purposeOfDiscussion[0].purpose) {
            content.push({ text: summary.purposeOfDiscussion[0].purpose, margin: [20, 0, 0, 10] });
        } else {
            content.push({ text: 'Not Specified', margin: [20, 0, 0, 10], italics: true });
        }

        // 4. Main Topics Discussed
        content.push({
            text: '4. Main Topics Discussed',
            style: 'sectionHeader',
            pageBreakBefore: true,
            keepWithNext: true
        });

        if (summary.mainTopicsDiscussed && summary.mainTopicsDiscussed.length > 0) {
            summary.mainTopicsDiscussed.forEach((topicSection: any, index: number) => {
                content.push({
                    text: `Topic ${index + 1}: ${topicSection.topic || 'Not Specified'}`,
                    style: 'subheader',
                    margin: [0, 10, 0, 5],
                    keepWithNext: true
                });

                if (topicSection.keyDiscussionPoints && topicSection.keyDiscussionPoints.length > 0) {
                    topicSection.keyDiscussionPoints.forEach((point: any) => {
                        // Discussion Points
                        content.push({
                            text: 'Discussion Points:',
                            style: 'subsubheader',
                            margin: [20, 5, 0, 5],
                            keepWithNext: true
                        });
                        if (point.discussionPoints && point.discussionPoints.length > 0) {
                            content.push(this.createBulletList(point.discussionPoints, 40));
                        } else {
                            content.push({ text: 'Not Specified', margin: [40, 0, 0, 5], italics: true });
                        }

                        // Context/Reason
                        content.push({
                            text: 'Context/Reason:',
                            style: 'subsubheader',
                            margin: [20, 5, 0, 5],
                            keepWithNext: true
                        });
                        content.push({
                            text: point.contextOrReason || 'Not Specified',
                            margin: [40, 0, 0, 5],
                            italics: !point.contextOrReason
                        });

                        // Immediate Implications/Concerns
                        content.push({
                            text: 'Immediate Implications/Concerns:',
                            style: 'subsubheader',
                            margin: [20, 5, 0, 5],
                            keepWithNext: true
                        });
                        content.push({
                            text: point.immediateImplicationsOrConcerns || 'Not Specified',
                            margin: [40, 0, 0, 10],
                            italics: !point.immediateImplicationsOrConcerns
                        });
                    });
                } else {
                    content.push({ text: 'No discussion points available', margin: [40, 0, 0, 10], italics: true });
                }
            });
        } else {
            content.push({ text: 'Not Specified', margin: [20, 0, 0, 10], italics: true });
        }

        // 5. Conclusions
        content.push({
            text: '5. Conclusions',
            style: 'sectionHeader',
            pageBreakBefore: true,
            keepWithNext: true
        });

        if (summary.conclusions && summary.conclusions.length > 0) {
            const conclusions = summary.conclusions.map((item: any) => item.conclusion).filter(Boolean);
            if (conclusions.length > 0) {
                content.push(this.createBulletList(conclusions, 20));
            } else {
                content.push({ text: 'Not Specified', margin: [20, 0, 0, 10], italics: true });
            }
        } else {
            content.push({ text: 'Not Specified', margin: [20, 0, 0, 10], italics: true });
        }

        // 6. Action Items
        content.push({
            text: '6. Action Items',
            style: 'sectionHeader',
            pageBreakBefore: true,
            keepWithNext: true
        });

        if (summary.actionItems && summary.actionItems.length > 0) {
            const actionItemsData = summary.actionItems.map((item: any) => ({
                task: item.task || 'Not Specified',
                responsibleParty: item.responsibleParty || 'Not Specified',
                deadline: item.deadline || 'Not Specified'
            }));
            content.push(this.createTable(actionItemsData, ['Task', 'Responsible Party', 'Deadline']));
        } else {
            content.push({ text: 'Not Specified', margin: [20, 0, 0, 10], italics: true });
        }

        // 7. Additional Notes
        content.push({
            text: '7. Additional Notes',
            style: 'sectionHeader',
            pageBreakBefore: true,
            keepWithNext: true
        });

        if (summary.additionalNotes && summary.additionalNotes.length > 0) {
            const notes = summary.additionalNotes.map((item: any) => item.notes).filter(Boolean);
            if (notes.length > 0) {
                content.push(this.createBulletList(notes, 20));
            } else {
                content.push({ text: 'Not Specified', margin: [20, 0, 0, 10], italics: true });
            }
        } else {
            content.push({ text: 'Not Specified', margin: [20, 0, 0, 10], italics: true });
        }

        return {
            ...this.getDocumentSettings(),
            content: content,
            styles: this.getDefaultStyles(),
            pageSize: 'A4',
            pageOrientation: 'portrait',
            pageMargins: [40, 60, 40, 60]
        };
    }
    private createBulletList(items: string[], indent: number = 0): any {
        if (!items || items.length === 0) {
            return {
                text: 'Not Specified',
                margin: [indent, 0, 0, 10],
                italics: true
            };
        }
        return {
            ul: items.map(item => ({
                text: item,
                margin: [0, 0, 0, 5]
            })),
            margin: [indent, 5, 0, 10]
        };
    }
    private getDocumentSettings(): any {
        return {
            pageSize: 'A4',
            pageOrientation: 'portrait',
            pageMargins: [40, 60, 40, 60],
            pageBreakBefore: (currentNode: any, followingNodesOnPage: any[], nodesOnNextPage: any[]) => {
                return (
                    currentNode.style === 'sectionHeader' &&
                    followingNodesOnPage.length < 2 &&
                    nodesOnNextPage.length > 0
                );
            }
        };
    }
    private createTable(data: any[], headers: string[]): any {
        const getColumnWidths = (headers: string[]) => {
            switch (headers.join(',')) {
                case 'Meeting Date,Meeting Time':
                    return ['50%', '50%'];
                case 'Full Name,Role,Special Designation':
                    return ['33%', '33%', '34%'];
                case 'Task,Responsible Party,Deadline':
                    return ['60%', '20%', '20%'];
                default:
                    return headers.map(() => `${100 / headers.length}%`);
            }
        };

        return {
            table: {
                headerRows: 1,
                widths: getColumnWidths(headers),
                body: [
                    headers.map((header) => ({
                        text: header,
                        style: 'tableHeader',
                        alignment: 'left',
                        fillColor: '#f2f2f2',
                        border: [true, true, true, true]
                    })),
                    ...data.map((item) =>
                        headers.map((header) => ({
                            text: item[this.camelCase(header)] || 'Not Specified',
                            style: 'tableCell',
                            alignment: 'left',
                            border: [true, true, true, true],
                            italics: !item[this.camelCase(header)]
                        }))
                    ),
                ],
                keepWithHeaderRows: 1
            },
            layout: {
                hLineWidth: () => 1,
                vLineWidth: () => 1,
                hLineColor: () => '#000000',
                vLineColor: () => '#000000',
                paddingLeft: () => 8,
                paddingRight: () => 8,
                paddingTop: () => 6,
                paddingBottom: () => 6
            },
            width: '100%',
            margin: [0, 5, 0, 15]
        };
    }
    private camelCase(str: string): string {
        return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
    }
    private getDefaultStyles(): any {
        return {
            header: {
                fontSize: 18,
                bold: true,
                margin: [0, 0, 0, 10],
            },
            sectionHeader: {
                fontSize: 14,
                bold: true,
                margin: [0, 15, 0, 10],
                keepWithNext: true,
                pageBreakBefore: true
            },
            tableHeader: {
                fontSize: 11,
                bold: true,
                color: '#000000',
                margin: [0, 2, 0, 2],
            },
            tableCell: {
                fontSize: 11,
                margin: [0, 2, 0, 2],
                lineHeight: 1.3,
            },
            subheader: {
                fontSize: 12,
                bold: true,
                margin: [0, 10, 0, 5],
            },
            subsubheader: {
                fontSize: 11,
                bold: true,
                margin: [0, 5, 0, 5],
            },
            bold: {
                bold: true
            }
        };
    }

    public refresh(): boolean {
        return false
    }
    deleteTickets($event: any) {
        const requestId = this.params.data.requestId
        this.createTicketService.deleteTicketModal.next(requestId)
    }

    deleteForecasting($event: any) {
        const requestId = this.params.data.requestId
        this.volumeForecastingService.deleteForecastingModal.next(requestId)
    }

    deleteDebtAnalysis($event: any) {
        const requestId = this.params.data.requestId
        this.debtAnalysisService.deleteDebtModal.next(requestId)
    }

    deleteFeedback($event: any) {
        const requestId = this.params.data.requestId
        this.customerSatisfactionService.deleteFeedbackModal.next(requestId)
    }
    deleteObservability($event: any) {
        const requestId = this.params.data.requestId
        this.debtAnalysisService.deleteDebtModal.next(requestId)
    }

    deleteLogAnalysis() {
        const requestId = this.params.data.requestId;
        if (requestId) {
            this.logAnalysisService.deleteLogAnalysis.next(requestId)
        }
    }

    deleteDocumentationRecord() {
        const requestId = this.params.data.requestId;
        if (requestId !== null && requestId !== undefined) {
            this.documentService.deleteDocRecord.next(requestId);
        }
    }

    viewChaosEngineering() {
        const requestId = this.params.data.requestId;
        if (requestId) {
            this.chaosService.setSelectedTestDesignRow(this.params.data)
            // localStorage.setItem('view', JSON.stringify(this.params.data));
            this.router.navigate(['/devops-automation/view-choas-engineering'],);
        } else {
            console.error('Request ID not found in params.data')
        }
    }

    deleteChaosRecord() {
        const requestId = this.params.data.requestId;
        if (requestId !== null && requestId !== undefined) {
            this.chaosService.deleteChaosRecord.next(requestId);
        }
    }
    public viewDocument(): void {
        if (this.isDownloadEnabled) {
            const requestId = this.params.data.requestId;
            if (requestId) {
                this.documentService.getDocumentResponse(requestId).subscribe({
                    next: (response: any) => {
                        if (response && response.status === 'Success') {
                            const docDefinition = this.generatePDFDocument(response);
                            pdfMake.createPdf(docDefinition).open();
                        } else {
                            console.error('Invalid response structure:', response);
                        }
                    },
                    error: (error: any) => {
                        console.error('Error fetching document response:', error);
                    },
                });
            } else {
                console.error('Request ID not found in params.data');
            }
        } else {
            console.warn('Preview not allowed. Document status is not Completed.');
        }
    }

    public deleteChaosManageRecord() {
        const jobId = this.params.data.jobId;
        if (jobId !== null && jobId !== undefined) {
            this.chaosService.deleteConfigRecord.next(jobId);
        }
    }

    public updateManageConfig(id: string) {
        const requestId = this.params.data;
        this.modalService.open(id);
        if (requestId !== null && requestId !== undefined) {
            this.chaosService.editManageConfiguration.next(requestId);
        }
    }

    public deleteFaqRecord() {
        const requestId = this.params.data.requestId;
        if (requestId !== null && requestId !== undefined) {
            this.faqService.deleteFaqRecord.next(requestId);

        }
    }

    // public updateSelfHelpPlaybook() {
    //     const playBookData = this.params.data;
    //     if (playBookData !== null && playBookData !== undefined) {
    //         this.chaosService.editSelfHelpPlaybook.next(playBookData);
    //         localStorage.setItem('playBookData', JSON.stringify(this.params.data));
    //         this.router.navigate(['devops-automation/create-new-playbook'], {
    //             queryParams: { id: playBookData.playbookId }
    //         })
    //     }
    // }

    public updateSelfHelpPlaybook() {
        const params: any = {
            selfHelpId: this.params.data.selfHelpId,
            mode:'edit'
        };
        const selfServiceBookData = this.params.data;
        if (selfServiceBookData !== null && selfServiceBookData !== undefined) {
            this.router.navigate(['devops-automation/new-playbook'], {
                queryParams: params
            })
        }
    }

    public deleteSelfHelpPlaybook() {
        const selfhelpId = this.params.data.selfHelpId;
        this.selfhelpService.deleteplaybookRecord.next(selfhelpId);
        
    }

    public updateChoasworkflow(){
        const params: any = {
            workflowId: this.params.data.workflowId,
            mode:'edit'
        };
        this.router.navigate(['/devops-automation/new-workflow'], {
            queryParams: params,
        });
    }

    public deleteWorkflowRecord(){
        const requestId = this.params.data.workflowId;        
        if (requestId !== null && requestId !== undefined) {
            this.chaosService.deleteWorflowRecord.next(requestId);
        }
    }
}

